import { useTranslation } from 'react-i18next';
import { Spell } from '../../Types/TableTypes';
import { Fragment } from 'react/jsx-runtime';
import SpellStatsComponent from './Spells/SpellStatsComponent';
import { useCallback, useEffect, useState } from 'react';
import SpellGroupComponent from './Spells/SpellGroupComponent';

interface SpellBlockComponentProps{
    spellcastingStats: {
        spellCharacteristic: string,
        spellSave: number,
        spellAttackMod: number,
        spellGroups: {
            label: string,
            hasSlotsGroup: boolean,
            hasSlotsEach: boolean,
            remainingSlots: number,
            maxSlots: number,
            list: Spell[]
        }[]
    }
    updateSpellcastingStats: (
        spellcastingStats: {
            spellCharacteristic: string,
            spellSave: number,
            spellAttackMod: number,
            spellGroups: {
                label: string,
                hasSlotsGroup: boolean,
                hasSlotsEach: boolean,
                remainingSlots: number,
                maxSlots: number,
                list: Spell[]
            }[]
        }) => void
    editMode: boolean
}

const SpellBlockComponent = (props: SpellBlockComponentProps)=> {
    const { t } = useTranslation();
    const [spellCharacteristic, setSpellCharacteristic] = useState(props.spellcastingStats.spellCharacteristic);
    const [spellSave, setSpellSave] = useState(props.spellcastingStats.spellSave);
    const [spellAttackMod, setSpellAttackMod] = useState(props.spellcastingStats.spellAttackMod);
    const [spellGroups, setSpellGroups] = useState(props.spellcastingStats.spellGroups);

    useEffect(()=> {
        setSpellCharacteristic(props.spellcastingStats.spellCharacteristic);
        setSpellSave(props.spellcastingStats.spellSave);
        setSpellAttackMod(props.spellcastingStats.spellAttackMod);
        setSpellGroups(props.spellcastingStats.spellGroups)
    },[props.spellcastingStats.spellAttackMod, props.spellcastingStats.spellCharacteristic, props.spellcastingStats.spellGroups, props.spellcastingStats.spellSave]);

    const updateStats = useCallback((spellCharacteristic: string, spellSave: number, spellAttackMod: number) => {
        setSpellCharacteristic(spellCharacteristic);
        setSpellSave(spellSave);
        setSpellAttackMod(spellAttackMod);
        props.spellcastingStats.spellCharacteristic = spellCharacteristic;
        props.spellcastingStats.spellAttackMod = spellAttackMod;
        props.spellcastingStats.spellSave = spellSave;
    },[props]);

    return(
        <div className='p-3'>
            <div>
                <h3>{t("section-spellcasting")}</h3>
                <div className="divider"></div>
            </div>
            <div className='spellblock fs-5 w-100'>    
                <div className="magic mb-4 w-100">
                    <SpellStatsComponent 
                        editMode={props.editMode}
                        spellCharacteristic={spellCharacteristic}
                        spellSave={spellSave}
                        spellAttackMod={spellAttackMod}
                        updateStats={updateStats}
                    ></SpellStatsComponent>
                    <div>
                        <span><b>{t("spell-spellgroups")}&nbsp;</b></span>
                        {props.editMode && 
                            <>
                                <span role="button" onClick={e=>{
                                    if (spellGroups && spellGroups.length > 0){  
                                        let newspellGroups = structuredClone(spellGroups);
                                        newspellGroups.splice(newspellGroups.length -1, 1);
                                        setSpellGroups([...newspellGroups]);
                                        props.spellcastingStats.spellGroups = newspellGroups;
                                    }
                                }}>
                                    <i className="bi bi-dash-circle"></i>
                                </span>
                                &nbsp;
                                <span role="button" onClick={e=>{
                                    let newGroups;
                                    if (spellGroups){
                                        newGroups = [...spellGroups, {label: "", hasSlotsGroup: false, hasSlotsEach: false, remainingSlots: 0, maxSlots: 0, list:[]}];
                                        
                                    }else{
                                        newGroups = [{label: "", hasSlotsGroup: false, hasSlotsEach: false, remainingSlots: 0, maxSlots: 0, list:[]}];
                                    }
                                    setSpellGroups (newGroups);
                                    props.spellcastingStats.spellGroups = newGroups;
                                }}>
                                    <i className="bi bi-plus-circle"></i>
                                </span>
                            </>
                        }
                        <div className={'d-flex flex-column '+props.editMode ? 'fs-6' : 'fs-5'}>
                        {spellGroups && spellGroups.map((spellGroup, index)=>{return(
                            <SpellGroupComponent 
                                key={"spellGroup-"+index+(props.editMode ? "-edit" : "-view")}
                                index={index}
                                editMode={props.editMode}
                                spellGroup={spellGroup}
                                updateSpellGroup={(newSpellGroup) => {
                                    spellGroup = newSpellGroup;
                                    setSpellGroups([...spellGroups])
                                    props.spellcastingStats.spellGroups = spellGroups;
                                }}
                            />
                        )})}
                        </div>
                    </div> 
                </div>
            </div>
        </div>
    )
}

export default SpellBlockComponent;